var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexIconCyrillicBlackwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 132C72 98.8629 98.8629 72 132 72C165.137 72 192 98.8629 192 132C192 165.137 165.137 192 132 192C98.8629 192 72 165.137 72 132Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.847 105.602H134.774C124.365 105.602 119.16 110.807 119.16 118.614C119.16 127.289 122.63 131.626 130.437 136.831L136.509 141.168L119.16 168.06H105.28L121.762 143.771C112.22 136.831 107.015 130.759 107.015 119.482C107.015 105.602 116.557 96.0601 134.774 96.0601H152.991V168.06H140.847V105.602Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexIconCyrillicBlackwhite);
export default __webpack_public_path__ + "static/media/yandex_icon_cyrillic_black+white.30c75f470f774e6e04e2d9e625177f87.svg";
export { ForwardRef as ReactComponent };